
import { Link } from 'react-router-dom';

export default function CtaSection() {
  return (
    <section className="relative py-20">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/cc182d92935ea8042eb74d36959df6a2.jpg"
          alt="Managed forest at sunset"
          className="w-full h-full object-cover object-top"
          onError={(e) => {
            // Fallback to a solid background color if image fails to load
            e.currentTarget.style.display = 'none';
          }}
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/40 to-black/50"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 text-center text-white">
        <h2 className="text-4xl font-bold mb-4">Ready to Scope Your Project?</h2>
        <p className="text-lg mb-8 max-w-2xl mx-auto leading-relaxed">
          The calculator gives you a planning estimate. A firm quote accounts for your specific terrain,
          access, and deliverable needs.
        </p>

        <div className="flex gap-4 justify-center">
          <Link
            to="/instant-quote"
            className="px-8 py-3 bg-amber-600 text-white rounded-lg font-semibold hover:bg-amber-700 transition whitespace-nowrap cursor-pointer"
          >
            Request a Firm Quote
          </Link>

          <Link
            to="/services/timber-forestry"
            className="px-8 py-3 bg-white text-stone-900 rounded-lg font-semibold hover:bg-stone-100 transition whitespace-nowrap cursor-pointer"
          >
            View All Forestry Services
          </Link>
        </div>
      </div>
    </section>
  );
}
